import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-background border-t border-white/5 text-center" role="contentinfo" data-id="element-103">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-104">
        <div className="mb-8" data-id="element-105">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-106">
            🔧 SISTEMA MAESTRO DE ALUMINIO
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-107">
            El sistema N°1 para carpinteros, armadores y dueños de taller de
            aluminio en Argentina.
          </p>
          <p className="text-gray-400" data-id="element-108">
            Porque trabajar con aluminio no debería costarte material perdido,
            reclamos evitables y presupuestos sin ganancia real.
          </p>
        </div>

        <nav aria-label="Contacto y redes sociales" className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-8" data-id="element-109">
          <a href="mailto:soporte@sistemamaestrodealuminio.com" className="hover:text-gold transition-colors" data-id="element-110">
            📧 soporteoficialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-111">
            |
          </span>
          <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-112">
            📲 @fegion1
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-113">
            |
          </span>
          <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-114">
            🌐 www.fegion.shop
          </a>
        </nav>

        <div className="border-t border-white/5 pt-8" data-id="element-115">
          <p className="text-gray-500 text-sm mb-6" data-id="element-116">
            © Sistema Maestro de Aluminio™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-117">
            <p data-id="element-118">🔧 "Desde hoy, tu taller tiene sistema."</p>
          </div>
        </div>
      </div>
    </footer>;
}